import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ViewToggle.css";

// role-aware view toggle — active state uses --role-accent
const ViewToggle = ({ options, value, onChange, darkMode }) => {
  return (
    <div className={`vt ${darkMode ? "vt--dark" : "vt--light"}`}>
      {options.map((opt) => (
        <button
          key={opt.value}
          className={`vt__btn${value === opt.value ? " vt__btn--active" : ""}`}
          onClick={() => onChange(opt.value)}
          title={opt.label}
          aria-label={opt.label}
        >
          <FontAwesomeIcon icon={opt.icon} />
        </button>
      ))}
    </div>
  );
};

ViewToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.object.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
};

export default ViewToggle;
